import { render, staticRenderFns } from "./CustomDataColumn.vue?vue&type=template&id=319a1845&"
import script from "./CustomDataColumn.vue?vue&type=script&lang=js&"
export * from "./CustomDataColumn.vue?vue&type=script&lang=js&"
import style0 from "./CustomDataColumn.vue?vue&type=style&index=0&id=319a1845&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports